var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { observable, computed, action, InternalMessageBusChannels, observe } from "../../../ExternalDependencies";
import { ShowMode } from "../../../Models";
import { getModalConfig, getWageringInformationSwitcherConfig, extractOptionsData, getDialogMessageConfig, getSetButtonProps, getLinkButtonProps, getLogOutButtonProps } from "../helpers";
export class RealityCheckState {
    constructor(options) {
        this.isUserLoggedIn = false;
        this.currencyCode = "";
        this.waitingSubmitResponse = false;
        this.selectedInterval = -1;
        this.showState = {
            mode: ShowMode.Closed
        };
        this.isValidationEnabled = false;
        this.intervalChangeHandler = (value) => {
            this.selectedInterval = parseInt(value);
        };
        this.linkButtonHandler = () => {
            this.close();
            window.location.assign(this.config.buttonLink);
        };
        this.modalCloseHandler = () => {
            this.close();
        };
        this.showMessageHandler = () => this.show();
        this.formatElapsedTime = (sessionStart) => {
            const elapsedMs = Date.now() - sessionStart.getTime();
            const elapsedHours = Math.floor(elapsedMs / (60 * 60 * 1000));
            const elapsedMinutes = Math.floor(elapsedMs % (60 * 60 * 1000) / (60 * 1000));
            const hoursFormatted = elapsedHours ? `${elapsedHours} ${this.dict.shortHourKey} ` : "";
            return `${hoursFormatted}${elapsedMinutes} ${this.dict.shortMinuteKey}`;
        };
        this.formatMoney = (amount) => {
            const formatter = this.localizationLib.getMoneyFormat(this.numberFormat);
            return formatter.format(amount);
        };
        this.dict = options.dict;
        this.config = options.cms;
        this.provider = options.provider;
        this.internalMessageBus = options.internalMessageBus;
        this.settings = options.provider.settings;
        this.logoutButtonHandler = options.logoutHandler;
        this.localizationLib = options.localizationLib;
        this.wageringInformation = options.provider.wageringInformation;
        this.modalConfig = getModalConfig(this.modalCloseHandler, this.config.closeByClickOnBackground);
        this.dialogMessageConfig = getDialogMessageConfig(this.config.title, this.config.description);
        this.wageringInformationSwitcherConfig = getWageringInformationSwitcherConfig(this.formatElapsedTime, this.formatMoney);
        this.linkButtonProps = getLinkButtonProps(this.dict.btnLink, this.linkButtonHandler);
        this.logoutButtonProps = getLogOutButtonProps(this.dict.btnLogOut, this.logoutButtonHandler);
    }
    activate() {
        this.provider.activate();
        this.internalMessageBus.on(InternalMessageBusChannels.realityCheck.show, this.showMessageHandler);
        this.userInfoObserverDisposer = observe(this.provider, "user", change => this.userChange(change.newValue));
    }
    deactivate() {
        this.internalMessageBus.off(InternalMessageBusChannels.realityCheck.show, this.showMessageHandler);
        this.provider.deactivate();
        this.userInfoObserverDisposer && this.userInfoObserverDisposer();
        clearInterval(this.timer);
    }
    get isOpen() {
        return Boolean(this.showState.mode);
    }
    get isIntervalValid() {
        return !this.isValidationEnabled || this.intervalOptions.some((interval) => interval.value === String(this.selectedInterval));
    }
    ;
    get buttons() {
        const buttonsProps = [this.setButtonProps, this.linkButtonProps, this.logoutButtonProps];
        if (!this.config.buttonLink) {
            buttonsProps.splice(1, 1);
        }
        return buttonsProps;
    }
    btnSetHandler() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isValidationEnabled = true;
            if (!this.isIntervalValid) {
                return;
            }
            this.waitingSubmitResponse = true;
            this.settings.interval = this.selectedInterval;
            yield this.provider.saveSettings(this.settings.interval);
            this.waitingSubmitResponse = false;
            this.close();
        });
    }
    close() {
        this.scheduleShowOnInterval(this.settings.interval);
        this.showState.mode = ShowMode.Closed;
        this.provider.saveShowState(this.showState);
        if (this.isShowEnabled) {
            this.provider.onClose();
        }
    }
    userChange(newValue) {
        return __awaiter(this, void 0, void 0, function* () {
            if (newValue) {
                this.isUserLoggedIn = true;
                this.currencyCode = newValue.currencyCode;
                const savedShowState = this.provider.getShowState();
                if (!savedShowState) {
                    yield this.handleLogin(newValue);
                }
                else {
                    yield this.handlePageReload(savedShowState);
                }
            }
            else {
                this.handleLogout();
            }
        });
    }
    handleLogin(user) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.config.showOnFirstLogin && user.isFirstLogin) {
                yield this.show(ShowMode.Auto);
            }
            else {
                yield this.getSettings();
                this.scheduleShowOnInterval(this.settings.interval);
            }
            this.provider.saveShowState(this.showState);
        });
    }
    handlePageReload(savedShowState) {
        return __awaiter(this, void 0, void 0, function* () {
            if (savedShowState.mode === ShowMode.Auto) {
                yield this.show(savedShowState.mode);
                return;
            }
            if (savedShowState.nextShowDate) {
                this.scheduleShowOnDate(savedShowState.nextShowDate);
            }
        });
    }
    handleLogout() {
        this.isUserLoggedIn = false;
        clearTimeout(this.timer);
        this.provider.removeShowState();
        this.showState.mode = ShowMode.Closed;
    }
    getSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.provider.getSettings();
            if (this.settings.interval === -1 && this.config.showWithDefaultInterval) {
                this.settings.interval = this.config.defaultInterval;
            }
        });
    }
    show(mode = ShowMode.Manual) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isShowEnabled) {
                this.close();
                return;
            }
            if (mode === ShowMode.Auto) {
                this.provider.saveShowState({ mode: ShowMode.Auto });
            }
            try {
                yield Promise.all([this.getSettings(), this.provider.getWageringInformation()]);
            }
            catch (e) {
                console.error(e);
                return;
            }
            if (mode === ShowMode.Auto && this.settings.interval === 0) {
                this.close();
                return;
            }
            this.selectedInterval = this.settings.interval;
            this.isValidationEnabled = false;
            this.showState.mode = mode;
            this.provider.onShow();
        });
    }
    get wageringInformationItemsParams() {
        return this.wageringInformationSwitcherConfig
            .filter(item => this.config[item.switcher])
            .map(item => ({
            key: item.dictKey,
            title: this.dict[item.dictKey],
            indicator: item.format(this.wageringInformation[item.wageringItem])
        }));
    }
    get intervalOptions() {
        return extractOptionsData(this.config.intervalOptions, this.dict.shortMinuteKey, this.config.showNoneOption, this.config.noneOptionText, this.settings.interval);
    }
    get setButtonProps() {
        return getSetButtonProps(this.dict.btnSet, this.btnSetHandler, this.waitingSubmitResponse);
    }
    get numberFormat() {
        return { style: "currency", currency: this.currencyCode };
    }
    get isShowEnabled() {
        return this.provider.isShowEnabled;
    }
    scheduleShowOnInterval(interval) {
        if (interval > 0) {
            this.showState.nextShowDate = new Date(Date.now() + interval * 60 * 1000);
            this.scheduleShowOnDate(this.showState.nextShowDate);
        }
        else {
            this.showState.nextShowDate = undefined;
            clearTimeout(this.timer);
        }
    }
    scheduleShowOnDate(date) {
        const timeout = date.getTime() - Date.now();
        clearTimeout(this.timer);
        this.timer = setTimeout(this.show, timeout, ShowMode.Auto);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], RealityCheckState.prototype, "settings", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RealityCheckState.prototype, "wageringInformation", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], RealityCheckState.prototype, "isUserLoggedIn", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], RealityCheckState.prototype, "currencyCode", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], RealityCheckState.prototype, "waitingSubmitResponse", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], RealityCheckState.prototype, "selectedInterval", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RealityCheckState.prototype, "showState", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], RealityCheckState.prototype, "isValidationEnabled", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], RealityCheckState.prototype, "isOpen", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], RealityCheckState.prototype, "isIntervalValid", null);
__decorate([
    action.bound,
    __metadata("design:type", Object)
], RealityCheckState.prototype, "intervalChangeHandler", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], RealityCheckState.prototype, "btnSetHandler", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], RealityCheckState.prototype, "close", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], RealityCheckState.prototype, "getSettings", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", Promise)
], RealityCheckState.prototype, "show", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], RealityCheckState.prototype, "wageringInformationItemsParams", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], RealityCheckState.prototype, "intervalOptions", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], RealityCheckState.prototype, "setButtonProps", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], RealityCheckState.prototype, "numberFormat", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], RealityCheckState.prototype, "isShowEnabled", null);
//# sourceMappingURL=RealityCheckState.js.map